import { Label, Table } from "@xola/ui-kit";
import { DateFormat, formatDate } from "common";
import React from "react";
import { PaymentMethodCopy, Transaction } from "types";
import { Currency } from "../../../Common/Currency";

export const PartnerReconciliationList = ({ transactions }: { transactions: Transaction[] }) => {
    return (
        <div className="flex h-auto w-full flex-col px-6">
            <Label class="pb-2 text-lg font-bold" data-testid="partner-paid-commissions-label">
                Paid Commissions
            </Label>
            <Table>
                <Table.Head>
                    <Table.Row>
                        <Table.Header>Date</Table.Header>
                        <Table.Header>Period</Table.Header>
                        <Table.Header>Note</Table.Header>
                        <Table.Header>Method</Table.Header>
                        <Table.Header>Amount</Table.Header>
                    </Table.Row>
                </Table.Head>

                <Table.Body isStriped>
                    {transactions.map(({ meta, id, createdAt, comment, method, amount }) => {
                        const startDate = meta?.start && formatDate(meta.start, DateFormat.DATE_SHORT);
                        const endDate = meta?.end && formatDate(meta.end, DateFormat.DATE_SHORT);

                        return (
                            <Table.Row key={id}>
                                <Table.Cell className="no-translate">
                                    {formatDate(createdAt, DateFormat.DATE_SHORT)}
                                </Table.Cell>
                                <Table.Cell className="no-translate">{`${startDate} - ${endDate}`}</Table.Cell>
                                <Table.Cell className="no-translate">{comment}</Table.Cell>
                                <Table.Cell>{PaymentMethodCopy[method]}</Table.Cell>
                                <Table.Cell>
                                    <Currency>{amount}</Currency>
                                </Table.Cell>
                            </Table.Row>
                        );
                    })}
                </Table.Body>
            </Table>
        </div>
    );
};
